import axios from "axios"

declare const apiEndpoint: string;
declare const searchApiEndpoint: string;
declare const clubfinderApiEndpoint: string;
declare const clubfinderCdnEndpoint: string;
declare const clubfinderSearchApiEndpoint: string;

export const sportmomentApi = axios.create({
    baseURL: apiEndpoint,
    headers: {
        "Content-Type": "application/json",
    },
    params: {
        host: location.host
    }
})

export const sportmomentSearchApiEndpoint = axios.create({
    baseURL: searchApiEndpoint,
    headers: {
        "Content-Type": "application/json",
    },
    params: {
        host: location.host
    }
})

export const clubfinderApi = axios.create({
    baseURL: clubfinderApiEndpoint,
    headers: {
        "Content-Type": "application/json",
    },
    params: {
        host: location.host
    }
})

export const clubfinderCdnApi = axios.create({
    baseURL: clubfinderCdnEndpoint,
    headers: {
        "Content-Type": "application/json",
    },
    params: {
        host: location.host
    }
})

export const clubfinderSearchApi = axios.create({
    baseURL: clubfinderSearchApiEndpoint,
    headers: {
        "Content-Type": "application/json",
    },
    params: {
        host: location.host
    }
})

export const umbracoApi = axios.create({
    baseURL: '/umbraco/api',
    headers: {
        "Content-Type": "application/json",
    },
})

export const googleMapsApi = axios.create({
    baseURL: "//maps.googleapis.com/maps/api",
    headers: {
        "Content-Type": "application/json",
    }
})